import { render, staticRenderFns } from "./rolling-stock-service.vue?vue&type=template&id=5c9e20ad&scoped=true"
import script from "./rolling-stock-service.vue?vue&type=script&lang=js"
export * from "./rolling-stock-service.vue?vue&type=script&lang=js"
import style0 from "./rolling-stock-service.vue?vue&type=style&index=0&id=5c9e20ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9e20ad",
  null
  
)

export default component.exports